/** @jsx jsx */
import { jsx } from '@emotion/react';
import { Alert, Link } from '@zapier/design-system';

import type { ResponseData } from '../useAlertBanner/useAlertBannerData';
import { BannerProps } from './types';

export const shouldRender = (data: ResponseData) => {
  const { currentAccount } = data;
  return (
    currentAccount.isTrialingEnterprise &&
    currentAccount.enterpriseTrialEndDate &&
    currentAccount.currentUserRole &&
    ['owner', 'admin', 'super_admin'].includes(currentAccount.currentUserRole)
  );
};

export const Component = function EnterpriseTrialing(props: BannerProps) {
  const { data } = props;
  const { currentAccount } = data;
  const { enterpriseTrialEndDate } = currentAccount;

  const title = 'Welcome to your Enterprise trial';

  const formattedEndDate = new Date(enterpriseTrialEndDate!)
    .toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    })
    .replace(/([a-z]+)/i, '$1.');

  return (
    <Alert layout={props.layout} title={title} type="info">
      <p data-zds>
        {`You will have access until ${formattedEndDate}. `}
        <Link href="https://zapier.com/enterprise">Learn more</Link> about
        Enterprise or{' '}
        <Link href="https://zapier.com/l/contact-sales?demo_source=enterprise-trial-banner-logged-in">
          contact Sales
        </Link>{' '}
        to upgrade.
      </p>
    </Alert>
  );
};
